<template>
  <g>
    <g clip-path="url(#clip0)">
      <path
        d="M62.2532 56.7123L49.79 60.4375L52.0733 68.1169L64.5365 64.3917L62.2532 56.7123Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M62.0389 56.9791L49.998 60.5781L52.1292 67.7458L64.17 64.1468L62.0389 56.9791Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M51.0253 62.0986L52.5576 61.6406L52.2196 60.5039L50.6873 60.9619L51.0253 62.0986Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M52.9395 63.93L58.8213 62.1719L58.7117 61.8033L52.8299 63.5614L52.9395 63.93Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M54.7737 64.2507L59.0625 62.9688L58.9894 62.723L54.7006 64.005L54.7737 64.2507Z"
          fill="#6C63FF"
        />
      </g>
      <path
        d="M81.6728 38.5089L80.145 46.3745L92.9104 48.867L94.4382 41.0014L81.6728 38.5089Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M81.5892 38.8576L80.1719 46.1875L92.4851 48.5811L93.9024 41.2512L81.5892 38.8576Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M81.9911 40.5607L83.5605 40.8672L83.7867 39.7029L82.2172 39.3964L81.9911 40.5607Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M82.8349 43.0737L88.8594 44.25L88.9327 43.8725L82.9083 42.6962L82.8349 43.0737Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M84.3133 44.2126L88.7061 45.0703L88.7549 44.8186L84.3621 43.9609L84.3133 44.2126Z"
          fill="#6C63FF"
        />
      </g>
      <path
        d="M89.6115 54.0371L82.2793 57.2261L87.4547 69.1886L94.7869 65.9997L89.6115 54.0371Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M89.4925 54.2658L82.6489 57.2422L87.6489 68.7994L94.4925 65.823L89.4925 54.2658Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M88.099 55.4667L88.7354 56.9375L89.8207 56.4654L89.1844 54.9947L88.099 55.4667Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M86.5087 57.5888L88.9512 63.2344L89.3031 63.0813L86.8606 57.4357L86.5087 57.5888Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M86.4046 59.4537L88.1855 63.5703L88.4202 63.4683L86.6392 59.3517L86.4046 59.4537Z"
          fill="#47E6B1"
        />
      </g>
      <path
        d="M54.0017 18.9388L41.5386 22.6641L43.8219 30.3435L56.285 26.6183L54.0017 18.9388Z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M53.7879 19.2135L41.7471 22.8125L43.8782 29.9802L55.9191 26.3812L53.7879 19.2135Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M42.7646 24.333L44.2969 23.875L43.9589 22.7382L42.4266 23.1962L42.7646 24.333Z"
          fill="#F55F44"
        />
        <path
          opacity="0.6"
          d="M44.6826 26.1643L50.5645 24.4062L50.4549 24.0377L44.573 25.7957L44.6826 26.1643Z"
          fill="#F55F44"
        />
        <path
          opacity="0.6"
          d="M46.5139 26.4851L50.8027 25.2031L50.7297 24.9574L46.4409 26.2393L46.5139 26.4851Z"
          fill="#F55F44"
        />
      </g>
      <path
        d="M73.4208 0.7359L71.8931 8.60156L84.6584 11.0941L86.1862 3.22843L73.4208 0.7359Z"
        fill="url(#paint4_linear)"
      />
      <path
        d="M73.5387 0.962669L72.1128 8.3042L84.4456 10.7123L85.8715 3.37073L73.5387 0.962669Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M73.7382 2.7873L75.3076 3.09375L75.5338 1.92942L73.9643 1.62297L73.7382 2.7873Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M74.5869 5.30025L80.6113 6.47656L80.6847 6.09904L74.6602 4.92272L74.5869 5.30025Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M76.0603 6.43915L80.4531 7.29688L80.502 7.04519L76.1092 6.18746L76.0603 6.43915Z"
          fill="#6C63FF"
        />
      </g>
      <path
        d="M81.3561 16.2647L74.0239 19.4536L79.1993 31.4162L86.5315 28.2273L81.3561 16.2647Z"
        fill="url(#paint5_linear)"
      />
      <path
        d="M81.2406 16.4923L74.397 19.4688L79.397 31.026L86.2406 28.0495L81.2406 16.4923Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M79.852 17.6933L80.4883 19.1641L81.5736 18.692L80.9373 17.2213L79.852 17.6933Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M78.2616 19.8154L80.7041 25.4609L81.056 25.3079L78.6136 19.6623L78.2616 19.8154Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M78.1575 21.6803L79.9385 25.7969L80.1731 25.6948L78.3921 21.5783L78.1575 21.6803Z"
          fill="#47E6B1"
        />
      </g>
      <path
        d="M18.9866 47.3685L6.52344 51.0938L8.80675 58.7732L21.2699 55.0479L18.9866 47.3685Z"
        fill="url(#paint6_linear)"
      />
      <path
        d="M18.7723 47.6354L6.73145 51.2344L8.8626 58.4021L20.9034 54.8031L18.7723 47.6354Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M7.75968 52.7627L9.29199 52.3047L8.954 51.1679L7.42169 51.6259L7.75968 52.7627Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M9.67776 54.594L15.5596 52.8359L15.45 52.4674L9.56817 54.2254L9.67776 54.594Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M11.5081 54.9147L15.7969 53.6328L15.7238 53.3871L11.435 54.669L11.5081 54.9147Z"
          fill="#6C63FF"
        />
      </g>
      <path
        d="M38.4115 29.1661L36.8838 37.0317L49.6491 39.5243L51.1769 31.6586L38.4115 29.1661Z"
        fill="url(#paint7_linear)"
      />
      <path
        d="M38.392 29.4514L36.9746 36.7812L49.2878 39.1748L50.7051 31.8449L38.392 29.4514Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M38.7235 31.217L40.293 31.5234L40.5191 30.3591L38.9497 30.0527L38.7235 31.217Z"
          fill="#F55F44"
        />
        <path
          opacity="0.6"
          d="M39.5722 33.7378L45.5967 34.9141L45.67 34.5365L39.6456 33.3602L39.5722 33.7378Z"
          fill="#F55F44"
        />
        <path
          opacity="0.6"
          d="M41.0457 34.8688L45.4385 35.7266L45.4874 35.4749L41.0945 34.6171L41.0457 34.8688Z"
          fill="#F55F44"
        />
      </g>
      <path
        d="M46.3483 44.6949L39.0161 47.8838L44.1915 59.8464L51.5237 56.6574L46.3483 44.6949Z"
        fill="url(#paint8_linear)"
      />
      <path
        d="M46.2313 44.921L39.3877 47.8975L44.3877 59.4547L51.2313 56.4782L46.2313 44.921Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M44.8363 46.123L45.4727 47.5938L46.558 47.1217L45.9217 45.6509L44.8363 46.123Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M43.246 48.2451L45.6885 53.8906L46.0404 53.7376L43.5979 48.092L43.246 48.2451Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M43.1419 50.11L44.9229 54.2266L45.1575 54.1245L43.3765 50.008L43.1419 50.11Z"
          fill="#47E6B1"
        />
      </g>
      <path
        d="M20.4534 24.806L7.99023 28.5312L10.2735 36.2107L22.7367 32.4854L20.4534 24.806Z"
        fill="url(#paint9_linear)"
      />
      <path
        d="M20.4613 24.956L8.39941 28.6094L10.5627 35.7896L22.6246 32.1363L20.4613 24.956Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M9.22159 30.208L10.7539 29.75L10.4159 28.6132L8.8836 29.0712L9.22159 30.208Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M11.1358 32.0393L17.0176 30.2812L16.908 29.9127L11.0262 31.6707L11.1358 32.0393Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M12.9709 32.3601L17.2598 31.0781L17.1867 30.8324L12.8979 32.1143L12.9709 32.3601Z"
          fill="#6C63FF"
        />
      </g>
      <path
        d="M39.7695 6.70104L38.251 14.5542L50.9961 17.0317L52.5146 9.17856L39.7695 6.70104Z"
        fill="url(#paint10_linear)"
      />
      <path
        d="M39.9943 6.83035L38.5684 14.1719L50.9012 16.5799L52.3271 9.23842L39.9943 6.83035Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M40.1893 8.6623L41.7588 8.96875L41.9849 7.80442L40.4155 7.49797L40.1893 8.6623Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M41.0332 11.1752L47.0576 12.3516L47.1309 11.974L41.1065 10.7977L41.0332 11.1752Z"
          fill="#6C63FF"
        />
        <path
          opacity="0.6"
          d="M42.5115 12.3141L46.9043 13.1719L46.9532 12.9202L42.5604 12.0625L42.5115 12.3141Z"
          fill="#F55F44"
        />
      </g>
      <path
        d="M47.8102 22.1387L40.478 25.3276L45.6534 37.2902L52.9856 34.1013L47.8102 22.1387Z"
        fill="url(#paint11_linear)"
      />
      <path
        d="M47.6952 22.3673L40.8516 25.3438L45.8516 36.901L52.6952 33.9245L47.6952 22.3673Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          opacity="0.6"
          d="M46.3022 23.5683L46.9385 25.0391L48.0238 24.567L47.3875 23.0962L46.3022 23.5683Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M44.7118 25.6904L47.1543 31.3359L47.5062 31.1829L45.0638 25.5373L44.7118 25.6904Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.6"
          d="M44.6077 27.5553L46.3887 31.6719L46.6233 31.5698L44.8423 27.4533L44.6077 27.5553Z"
          fill="#47E6B1"
        />
      </g>
      <path
        opacity="0.25"
        d="M8.32994 8.57216C8.70497 8.57216 9.009 8.26733 9.009 7.8913C9.009 7.51528 8.70497 7.21045 8.32994 7.21045C7.9549 7.21045 7.65088 7.51528 7.65088 7.8913C7.65088 8.26733 7.9549 8.57216 8.32994 8.57216Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M79.222 68.2054C79.5971 68.2054 79.9011 67.9006 79.9011 67.5246C79.9011 67.1486 79.5971 66.8438 79.222 66.8438C78.847 66.8438 78.543 67.1486 78.543 67.5246C78.543 67.9006 78.847 68.2054 79.222 68.2054Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M19.2357 64.8148C19.6107 64.8148 19.9148 64.51 19.9148 64.134C19.9148 63.758 19.6107 63.4531 19.2357 63.4531C18.8607 63.4531 18.5566 63.758 18.5566 64.134C18.5566 64.51 18.8607 64.8148 19.2357 64.8148Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M85.5326 55.3461C85.9076 55.3461 86.2116 55.0413 86.2116 54.6652C86.2116 54.2892 85.9076 53.9844 85.5326 53.9844C85.1575 53.9844 84.8535 54.2892 84.8535 54.6652C84.8535 55.0413 85.1575 55.3461 85.5326 55.3461Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M91.9227 24.1117C92.2977 24.1117 92.6018 23.8069 92.6018 23.4309C92.6018 23.0548 92.2977 22.75 91.9227 22.75C91.5477 22.75 91.2437 23.0548 91.2437 23.4309C91.2437 23.8069 91.5477 24.1117 91.9227 24.1117Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M41.7867 0.871797H41.1834V0.265625H40.9363V0.871797H40.333V1.11825H40.9363V1.72318H41.1834V1.11825H41.7867V0.871797Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M18.5543 10.1518H17.951V9.54688H17.7039V10.1518H17.1006V10.3995H17.7039V11.0044H17.951V10.3995H18.5543V10.1518Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M9.10508 44.7143H8.50174V44.1094H8.2547V44.7143H7.65137V44.962H8.2547V45.5669H8.50174V44.962H9.10508V44.7143Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M7.74987 20.0593H7.1453V19.4531H6.8995V20.0593H6.29492V20.3058H6.8995V20.9119H7.1453V20.3058H7.74987V20.0593Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M1.84726 37.0051H1.24393V36.3989H0.998129V37.0051H0.393555V37.2516H0.998129V37.8565H1.24393V37.2516H1.84726V37.0051Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M108.048 28.27H107.445V27.665H107.198V28.27H106.595V28.5177H107.198V29.1226H107.445V28.5177H108.048V28.27Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M87.0167 36.1452H86.4134V35.5391H86.1663V36.1452H85.563V36.3917H86.1663V36.9979H86.4134V36.3917H87.0167V36.1452Z"
        fill="#535461"
      />
      <path
        opacity="0.25"
        d="M69.0565 14.9018H68.4519V14.2969H68.2061V14.9018H67.6016V15.1495H68.2061V15.7544H68.4519V15.1495H69.0565V14.9018Z"
        fill="#535461"
      />
      <path
        d="M34.3941 49.5234C33.9596 50.9374 34.6114 52.6091 35.8838 53.3534C36.4164 53.6646 37.0309 53.8227 37.5486 54.16C38.6721 54.8931 39.1152 56.2996 39.4802 57.5929C39.8986 59.0803 40.3194 60.6524 39.9358 62.1485C39.6875 63.1019 39.1351 63.9459 38.8185 64.8794C38.5541 65.661 38.4622 66.4908 38.5492 67.3115C38.5951 67.7472 38.7043 68.2003 39.001 68.5214C39.4306 68.9857 40.1183 69.0554 40.739 69.1674C42.0536 69.4177 43.2904 69.9768 44.3478 70.799C45.4051 71.6212 46.2531 72.683 46.822 73.8973"
        stroke="url(#paint12_linear)"
        stroke-width="0.45044"
        stroke-miterlimit="10"
      />
      <path
        d="M34.5303 49.5234C34.0958 50.9374 34.7476 52.6091 36.02 53.3534C36.5526 53.6646 37.1671 53.8227 37.6848 54.16C38.8083 54.8931 39.2515 56.2996 39.6165 57.5929C40.0348 59.0803 40.4557 60.6524 40.0721 62.1485C39.8238 63.1019 39.2713 63.9459 38.9548 64.8794C38.6904 65.661 38.5985 66.4908 38.6854 67.3115C38.7313 67.7472 38.8406 68.2003 39.1373 68.5214C39.5668 68.9857 40.2546 69.0554 40.8753 69.1674C42.1899 69.4177 43.4266 69.9768 44.484 70.799C45.5414 71.6212 46.3893 72.683 46.9583 73.8973"
        stroke="#535461"
        stroke-width="0.45044"
        stroke-miterlimit="10"
      />
      <path
        d="M50.9761 38.9531C49.9048 40.4468 48.7925 42.0649 48.7006 43.9033C48.5603 46.7325 50.811 49.0465 51.8253 51.6927C52.2615 52.8581 52.4589 54.0998 52.4055 55.3434C52.3522 56.587 52.0493 57.8071 51.5149 58.9307C51.0184 59.9501 50.3219 60.962 50.4076 62.091C50.4597 62.7805 50.8036 63.4066 51.0804 64.0402C51.7598 65.6278 52.0564 67.3537 51.9459 69.0778C51.8355 70.8019 51.3212 72.4755 50.4448 73.963"
        stroke="url(#paint13_linear)"
        stroke-width="0.45044"
        stroke-miterlimit="10"
      />
      <path
        d="M51.1041 38.9531C50.0327 40.4468 48.9204 42.0649 48.8285 43.9033C48.6883 46.7325 50.939 49.0465 51.9532 51.6927C52.3896 52.858 52.5872 54.0996 52.5341 55.3433C52.4809 56.5869 52.1783 57.807 51.6441 58.9307C51.1475 59.9501 50.4511 60.962 50.5367 62.091C50.5889 62.7805 50.9327 63.4066 51.2096 64.0402C51.889 65.6278 52.1855 67.3537 52.0751 69.0778C51.9646 70.8019 51.4504 72.4755 50.574 73.963"
        stroke="#535461"
        stroke-width="0.45044"
        stroke-miterlimit="10"
      />
      <path
        d="M66.0177 52.4297L66.5353 56.6617C66.6036 57.2243 66.6595 57.8379 66.3615 58.3172C66.076 58.7715 65.541 58.9881 65.1201 59.3241C63.7545 60.4257 63.8787 62.5417 64.3455 64.2382C64.8122 65.9348 65.4975 67.757 64.842 69.3888C64.5714 70.0622 64.0972 70.6335 63.7359 71.2559C63.1305 72.3364 62.8905 73.5845 63.0519 74.8133"
        stroke="url(#paint14_linear)"
        stroke-width="0.45044"
        stroke-miterlimit="10"
      />
      <path
        d="M66.1368 52.4297L66.6545 56.6617C66.7228 57.2243 66.7786 57.8379 66.4807 58.3172C66.1952 58.7715 65.6601 58.9881 65.2393 59.3241C63.8737 60.4257 63.9978 62.5417 64.4646 64.2382C64.9314 65.9348 65.6166 67.757 64.9612 69.3888C64.6905 70.0622 64.2163 70.6335 63.8551 71.2559C63.2496 72.3364 63.0096 73.5845 63.171 74.8133"
        stroke="#535461"
        stroke-width="0.45044"
        stroke-miterlimit="10"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M79.4466 35.0241C79.445 33.0433 78.9762 31.091 78.0784 29.3266C77.1805 27.5622 75.8792 26.0357 74.2807 24.8718C72.6821 23.708 70.8317 22.9397 68.8805 22.6298C66.9293 22.3198 64.9326 22.4771 63.0536 23.0886C63.1571 22.3829 63.2106 21.6708 63.2137 20.9576C63.2338 17.6936 61.9849 14.55 59.7319 12.1939C57.4789 9.83766 54.399 8.45413 51.1456 8.33674C47.8922 8.21935 44.7211 9.37733 42.3051 11.565C39.889 13.7528 38.4179 16.7981 38.2039 20.0552C36.3246 19.4425 34.3274 19.2844 32.3754 19.5937C30.4235 19.9029 28.5722 20.6709 26.9729 21.8348C25.3736 22.9986 24.0716 24.5254 23.1734 26.2903C22.2752 28.0551 21.8062 30.0081 21.8047 31.9895C21.8047 38.2877 26.4302 47.2458 32.4623 48.8328L33.3996 49.3706L32.8906 51.1206H35.9073L35.2518 49.3681L36.1854 48.8328C40.8457 47.6068 44.6656 41.9807 46.1627 36.58C46.9816 37.1276 47.8833 37.539 48.833 37.7985L49.7703 38.3362L49.2613 40.0863H52.278L51.6225 38.3337L52.5561 37.7985C53.2488 37.6116 53.9159 37.3399 54.5423 36.9895C55.348 43.045 59.6322 50.4398 65.0622 51.8674L65.9995 52.4052L65.4905 54.1552H68.5071L67.8517 52.4027L68.7852 51.8674C74.826 50.2804 79.4466 41.3223 79.4466 35.0241Z"
          fill="url(#paint15_linear)"
        />
      </g>
      <path
        d="M36.3864 50.475H33.4678L33.978 48.7188H35.7297L36.3864 50.475Z"
        fill="#F55F44"
      />
      <path
        d="M46.9699 31.9662C46.9699 38.6739 41.5461 48.5021 34.856 48.5021C28.166 48.5021 22.7422 38.6689 22.7422 31.9662C22.7422 28.7449 24.0185 25.6555 26.2902 23.3777C28.562 21.1 31.6432 19.8203 34.856 19.8203C38.0688 19.8203 41.15 21.1 43.4218 23.3777C45.6936 25.6555 46.9699 28.7449 46.9699 31.9662Z"
        fill="#F55F44"
      />
      <path
        d="M35.7304 48.7955H33.9787L32.957 48.2104H36.7521L35.7304 48.7955Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M30.4773 22.5312C30.4773 22.5312 25.3688 25.3119 24.6426 30.8708L30.4773 22.5312Z"
        fill="white"
      />
      <path
        d="M52.2296 39.8032H49.311L49.8213 38.0469H51.5729L52.2296 39.8032Z"
        fill="#4D8AF0"
      />
      <path
        d="M62.8122 21.2865C62.8122 27.9942 57.3884 37.8224 50.6983 37.8224C44.0083 37.8224 38.582 27.9954 38.582 21.2865C38.582 18.0652 39.8583 14.9759 42.1301 12.6981C44.4019 10.4203 47.4831 9.14063 50.6959 9.14062C53.9086 9.14063 56.9898 10.4203 59.2616 12.6981C61.5334 14.9759 62.8097 18.0652 62.8097 21.2865H62.8122Z"
        fill="#4D8AF0"
      />
      <path
        d="M51.5697 38.1175H49.8181L48.7964 37.5312H52.5914L51.5697 38.1175Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M46.3191 11.8438C46.3191 11.8438 41.2106 14.6244 40.4844 20.1833L46.3191 11.8438Z"
        fill="white"
      />
      <path
        d="M67.9384 53.4113H65.0186L65.53 51.6562H67.2804L67.9384 53.4113Z"
        fill="#3AD29F"
      />
      <path
        d="M78.5206 34.9032C78.5206 41.6109 73.0969 51.4391 66.4068 51.4391C59.7168 51.4391 54.293 41.6059 54.293 34.9032C54.293 31.6819 55.5692 28.5926 57.841 26.3148C60.1128 24.037 63.194 22.7573 66.4068 22.7573C69.6196 22.7573 72.7008 24.037 74.9726 26.3148C77.2444 28.5926 78.5206 31.6819 78.5206 34.9032Z"
        fill="#3AD29F"
      />
      <path
        d="M67.2799 51.7256H65.5295L64.5078 51.1406H68.3016L67.2799 51.7256Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M62.0251 25.4688C62.0251 25.4688 56.9167 28.2494 56.1904 33.8083L62.0251 25.4688Z"
        fill="white"
      />
      <path
        d="M70.5558 71.8361L37.0547 73.5156L38.0841 94.1591L71.5852 92.4796L70.5558 71.8361Z"
        fill="url(#paint16_linear)"
      />
      <path
        d="M69.8268 72.1694L37.5039 73.8281L38.4861 93.0685L70.809 91.4098L69.8268 72.1694Z"
        fill="#EEEEEE"
      />
      <path
        d="M39.1298 78.2804L43.2422 78.0693L43.0864 75.0175L38.974 75.2286L39.1298 78.2804Z"
        fill="#6C63FF"
      />
      <path
        d="M42.8058 84.0457L58.5972 83.2354L58.5467 82.2458L42.7553 83.0562L42.8058 84.0457Z"
        fill="#6C63FF"
      />
      <path
        d="M47.1917 85.9659L58.707 85.375L58.6733 84.7149L47.158 85.3059L47.1917 85.9659Z"
        fill="#6C63FF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="58.3049"
        y1="66.2543"
        x2="56.0105"
        y2="58.5782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="654.719"
        y1="4564.51"
        x2="815.581"
        y2="3740.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-4590.72"
        y1="4097.66"
        x2="-3821.96"
        y2="3765.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="863.184"
        y1="2311.46"
        x2="715.471"
        y2="1817.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="411.978"
        y1="690.291"
        x2="572.84"
        y2="-133.557"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="-4809.49"
        y1="1538.93"
        x2="-4040.73"
        y2="1206.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="-2961.17"
        y1="4640.6"
        x2="-3108.9"
        y2="4146.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="-2079.57"
        y1="3927.32"
        x2="-1918.71"
        y2="3103.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="-8683.37"
        y1="4112.1"
        x2="-7914.61"
        y2="3779.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint9_linear"
        x1="-2571.55"
        y1="3076.57"
        x2="-2719.26"
        y2="2582.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint10_linear"
        x1="-1805.44"
        y1="1562.83"
        x2="-1645.55"
        y2="740.294"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint11_linear"
        x1="-8187.64"
        y1="2483.6"
        x2="-7418.88"
        y2="2151.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint12_linear"
        x1="5539.29"
        y1="13877.5"
        x2="6835.46"
        y2="13877.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint13_linear"
        x1="2111.13"
        y1="18423.3"
        x2="2230.05"
        y2="18423.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint14_linear"
        x1="2464.88"
        y1="13095.6"
        x2="2575.7"
        y2="13095.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint15_linear"
        x1="32938.8"
        y1="23223.6"
        x2="32938.8"
        y2="6379.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint16_linear"
        x1="165.175"
        y1="16311.1"
        x2="-6.46143"
        y2="12887.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <clipPath id="clip0">
        <rect
          x="0.393555"
          y="0.265625"
          width="107.655"
          height="93.6916"
          fill="white"
        />
      </clipPath>
    </defs>
  </g>
</template>
